export default __webpack_public_path__ + "static/DawidJozwiak-19835909bd12d8d9f58e2d020864dc2d.jpeg";